import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
export function PageFooter() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal text-cream-dark py-12 px-4 text-center" data-id="element-115">
        <div className="max-w-4xl mx-auto" data-id="element-116">
          <h3 className="font-heading text-2xl text-gold mb-4" data-id="element-117">
            Legado Digital Seguro
          </h3>
          <p className="mb-6 opacity-80" data-id="element-118">
            Ayudando a familias a preservar su historia y patrimonio con
            dignidad y orden.
          </p>
          <div className="flex justify-center gap-6 text-sm opacity-60 mb-8" data-id="element-119">
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold transition-colors cursor-pointer bg-transparent border-none text-cream-dark" data-id="element-120">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold transition-colors cursor-pointer bg-transparent border-none text-cream-dark" data-id="element-121">
              Política de Privacidad
            </button>
          </div>
          <p className="text-sm opacity-50" data-id="element-122">
            &copy; {new Date().getFullYear()} Legado Digital Seguro. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-123">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" data-id="element-124" />

          {/* Modal Content */}
          <div className="relative bg-cream w-full max-w-2xl max-h-[85vh] rounded-sm shadow-2xl border-2 border-gold/40 overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-125">
            {/* Header */}
            <div className="flex items-center justify-between px-8 py-5 bg-burgundy text-white border-b-2 border-gold shrink-0" data-id="element-126">
              <h3 className="font-heading text-2xl text-white" data-id="element-127">
                {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="text-white/80 hover:text-gold transition-colors p-1" aria-label="Cerrar" data-id="element-128">
                <X className="w-6 h-6" data-id="element-129" />
              </button>
            </div>

            {/* Body */}
            <div className="px-8 py-6 overflow-y-auto text-charcoal text-base leading-relaxed" data-id="element-130">
              {activeModal === 'terms' ? <TermsContent data-id="element-131" /> : <PrivacyContent data-id="element-132" />}
            </div>

            {/* Footer */}
            <div className="px-8 py-4 border-t border-gold/20 bg-cream-dark shrink-0 text-center" data-id="element-133">
              <button onClick={() => setActiveModal(null)} className="px-8 py-3 bg-burgundy text-white font-semibold hover:bg-burgundy-light transition-colors rounded-sm shadow-md" data-id="element-134">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function TermsContent() {
  return <div className="space-y-6" data-id="element-135">
      <p className="text-sm text-charcoal-light italic" data-id="element-136">
        Última actualización: Marzo 2026
      </p>

      <div data-id="element-137">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-138">
          1. Aceptación de los Términos
        </h4>
        <p data-id="element-139">
          Al adquirir y utilizar el producto "Legado Digital Seguro", usted
          acepta estos términos y condiciones en su totalidad. Si no está de
          acuerdo con alguna parte de estos términos, le recomendamos no
          realizar la compra.
        </p>
      </div>

      <div data-id="element-140">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-141">
          2. Descripción del Producto
        </h4>
        <p data-id="element-142">
          "Legado Digital Seguro" es un producto digital en formato PDF que
          incluye guías, plantillas y recursos educativos para ayudarle a
          organizar su información digital. El producto se entrega mediante
          descarga electrónica inmediata después de la compra.
        </p>
      </div>

      <div data-id="element-143">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-144">
          3. Uso del Producto
        </h4>
        <p data-id="element-145">
          El producto es para uso personal y familiar únicamente. Queda
          prohibida la reproducción, distribución o reventa del material sin
          autorización expresa por escrito. Usted puede imprimir las plantillas
          incluidas para su uso personal.
        </p>
      </div>

      <div data-id="element-146">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-147">
          4. Precio y Pago
        </h4>
        <p data-id="element-148">
          El precio del producto es el indicado en la página de venta al momento
          de la compra. Todos los pagos se procesan de forma segura. El precio
          incluye acceso completo a todos los materiales descritos en la oferta.
        </p>
      </div>

      <div data-id="element-149">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-150">5. Entrega</h4>
        <p data-id="element-151">
          El acceso al producto digital se proporciona de forma inmediata tras
          la confirmación del pago. Recibirá un enlace de descarga en su correo
          electrónico. Es su responsabilidad guardar una copia del material
          descargado.
        </p>
      </div>

      <div data-id="element-152">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-153">
          6. Limitación de Responsabilidad
        </h4>
        <p data-id="element-154">
          Este producto tiene fines educativos e informativos. No constituye
          asesoría legal, financiera ni tecnológica profesional. Le recomendamos
          consultar con profesionales especializados para situaciones
          específicas relacionadas con su patrimonio o herencia.
        </p>
      </div>

      <div data-id="element-155">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-156">
          7. Propiedad Intelectual
        </h4>
        <p data-id="element-157">
          Todo el contenido del producto, incluyendo textos, diseños y
          plantillas, está protegido por derechos de autor. El "Método del Ancla
          Analógica" es una metodología original de Legado Digital Seguro.
        </p>
      </div>
    </div>;
}
function PrivacyContent() {
  return <div className="space-y-6" data-id="element-158">
      <p className="text-sm text-charcoal-light italic" data-id="element-159">
        Última actualización: Marzo 2026
      </p>

      <div data-id="element-160">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-161">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-162">
          Al realizar su compra, recopilamos únicamente la información necesaria
          para procesar su pedido: nombre, dirección de correo electrónico y
          datos de pago. No almacenamos información de tarjetas de crédito en
          nuestros servidores.
        </p>
      </div>

      <div data-id="element-163">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-164">
          2. Uso de su Información
        </h4>
        <p data-id="element-165">
          Su información personal se utiliza exclusivamente para: procesar y
          entregar su compra, enviarle el enlace de descarga del producto, y
          comunicarle actualizaciones importantes relacionadas con su compra.
        </p>
      </div>

      <div data-id="element-166">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-167">
          3. Protección de Datos
        </h4>
        <p data-id="element-168">
          Implementamos medidas de seguridad adecuadas para proteger su
          información personal contra acceso no autorizado, alteración o
          destrucción. Utilizamos encriptación SSL para todas las transacciones.
        </p>
      </div>

      <div data-id="element-169">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-170">
          4. No Compartimos su Información
        </h4>
        <p data-id="element-171">
          No vendemos, intercambiamos ni transferimos su información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          necesarios para procesar su transacción de forma segura.
        </p>
      </div>

      <div data-id="element-172">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-173">5. Cookies</h4>
        <p data-id="element-174">
          Nuestro sitio puede utilizar cookies para mejorar su experiencia de
          navegación. Estas cookies no contienen información personal y puede
          desactivarlas en la configuración de su navegador.
        </p>
      </div>

      <div data-id="element-175">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-176">
          6. Sus Derechos
        </h4>
        <p data-id="element-177">
          Usted tiene derecho a acceder, rectificar o solicitar la eliminación
          de sus datos personales en cualquier momento. Este derecho se aplica
          independientemente de su país de residencia.
        </p>
      </div>

      <div data-id="element-178">
        <h4 className="font-heading text-xl text-burgundy mb-2" data-id="element-179">
          7. Cambios en esta Política
        </h4>
        <p data-id="element-180">
          Nos reservamos el derecho de actualizar esta política de privacidad.
          Cualquier cambio significativo será comunicado a través de nuestro
          sitio web.
        </p>
      </div>
    </div>;
}